import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { CommonService } from '../../../../shared/common.service';
import { StatementService } from './statement.service';
import * as CryptoJS from 'crypto-js';
import { AccountingPeriodService } from '../../accounting-period/services/accounting-period.service';
import Swal from 'sweetalert2';
import { Observable } from 'rxjs';
import { SideNavService } from '../../../../theme/layout/admin/navigation/service/side-nav.service';
@Component({
  selector: 'app-statementcompliance',
  templateUrl: './statementcompliance.component.html',
  styleUrls: ['./statementcompliance.component.scss']
})
export class StatementcomplianceComponent implements OnInit {
  statementform: FormGroup; APPeriodId: any; AccountsTemplate: any; defaultstatement: any; Template: any; AccountsTemplate1: any; isJump: any;
  NormalRoutng: boolean;
  showBubbledata: any;
  showbubble:any

  constructor(private formbuilder: FormBuilder, public Statementcompliance: StatementService, public commonService: CommonService, public router: Router, public accountsService: AccountingPeriodService, public sidenav: SideNavService) { }
  ngOnInit() {
    debugger
    this.APPeriodId = CryptoJS.AES.decrypt(localStorage.getItem("APPeriodId"), "APS").toString(CryptoJS.enc.Utf8);
    this.commonService.getIncomeStatementsHeaders();
    this.isJump = localStorage.getItem('isJump');
    this.getAccountsTemplate();
    this.createstatement();
    this.getstatement(this.APPeriodId)
    this.getBasicInfodata();
    this.commonService.Showbubble.subscribe((data) => {
      if (data) {
        this.commonService.getImportPageSelectionData(this.commonService.AccountTemplateId, CryptoJS.AES.decrypt(localStorage.getItem("companyId"), "APS").toString(CryptoJS.enc.Utf8), CryptoJS.AES.decrypt(localStorage.getItem("APPeriodId"), "APS").toString(CryptoJS.enc.Utf8)).subscribe((data) => {
          this.commonService.showBubble = data[0].ImportStatus
          if (this.commonService.showBubble) {
            this.sidenav.setShowBubble(true);
            this.getlastyeardata()
          }
        })
      }
      else {
        this.showBubbledata = null
      }
    })
    if (localStorage.getItem("SubmitStatus") == "true")
      this.statementform.disable()
  }
  createstatement() {
    this.statementform = this.formbuilder.group({
      APPeriodId: new FormControl(),
      StatementOfComplianceId: new FormControl(),
      TextComment: new FormControl(),
      CreatedBy: new FormControl()
    })
  }
  getBasicInfodata() {
    debugger
    let id = CryptoJS.AES.decrypt(localStorage.getItem("APPeriodId"), "APS").toString(CryptoJS.enc.Utf8)
    this.accountsService.getBasicInfoData(id).subscribe((data: any) => {
      this.AccountsTemplate = data;
      var finaldata = this.AccountsTemplate1.filter((x) => x.AccountsTemplateId == data.DimensionLegalFormEntity)
      this.Template = finaldata[0].AccountsTemplateName;
      if (this.Template == "Small Company (FRS 102)") {
        this.defaultstatement = "FRS 102 - These financial statements have been prepared in compliance with FRS 102 - The Financial Reporting Standard applicable in the UK and Republic of Ireland (March 2018) and the Companies Act 2006."
      }
      if (this.Template == "Medium or Large Company (FRS 101)") {
        this.defaultstatement = "FRS 101 - These financial statements have been prepared in compliance with FRS 101 - The Financial Reporting Standard applicable in the UK and Republic of Ireland (March 2018) and the Companies Act 2006."
      }
      if (this.Template == "Small Company (FRS 102(1A))") {
        this.defaultstatement = "FRS 102(1A) - The financial statements have been prepared in accordance with FRS 102 Section 1A - The Financial Reporting Standard applicable in the UK and Republic of Ireland (March 2018) and the Companies Act 2006."
      }
      if (this.Template == "Micro-Entity Company (FRS 105)") {
        this.defaultstatement = "FRS 105 - The financial statements have been prepared in accordance with the micro-entity provisions of the companies Act 2006 and FRS 105 The Financial Reporting Standard applicable to the Micro-entities Regime(March 2018)"
      }
      if (this.Template == "Small Limited Liability Partnership (FRS 102)") {
        this.defaultstatement = "FRS 102 - These financial statements have been prepared in compliance with FRS 102 - The Financial Reporting Standard applicable in the UK and Republic of Ireland (March 2018) and the Companies Act 2006."
      }
      if (this.Template == "Micro-Entity Limited Liability Partnership (FRS105)") {
        this.defaultstatement = "FRS 105 - The financial statements have been prepared in accordance with the micro-entity provisions of the Companies Act 2006 and FRS 105 The Financial Reporting Standard applicable to the Micro-entities Regime(March 2018)."
      }
      if (this.Template == "Small Company Dormant (FRS 102)") {
        this.defaultstatement = "FRS 102 - These financial statements have been prepared in compliance with FRS 102 - The Financial Reporting Standard applicable in the UK and Republic of Ireland (March 2018) and the Companies Act 2006."
      }
      if (this.Template == "Micro-Entity Company Dormant (FRS 105)") {
        this.defaultstatement = "FRS 105 - The financial statements have been prepared in accordance with the micro-entity provisions of the Companies Act 2006 and FRS 105 The Financial Reporting Standard applicable to the Micro-entities Regime(March 2018)."
      }
      if (this.Template == "Dormant Small Limited Liability Partnership (FRS)") {
        this.defaultstatement = "FRS 102 - These financial statements have been prepared in compliance with FRS 102 - The Financial Reporting Standard applicable in the UK and Republic of Ireland (March 2018) and the Companies Act 2006."
      }
      if (this.Template == "Micro-Entity Company Dormant (FRS 105)") {
        this.defaultstatement = "FRS 105 - The financial statements have been prepared in accordance with the micro-entity provisions of the Companies Act 2006 and FRS 105 The Financial Reporting Standard applicable to the Micro-entities Regime(March 2018)."
      }

      this.statementform.controls['TextComment'].setValue(this.defaultstatement);
    })
  }
  getAccountsTemplate() {
    debugger
    var entityid = CryptoJS.AES.decrypt(localStorage.getItem("EntityId"), "APS").toString(CryptoJS.enc.Utf8)
    var legalformId = CryptoJS.AES.decrypt(localStorage.getItem("legalFormId"), "APS").toString(CryptoJS.enc.Utf8)
    this.commonService.getAccountingPeriod_AccountsTemplate(legalformId, entityid).subscribe(data => {
      this.AccountsTemplate1 = data;
      this.getBasicInfodata();
    })
  }
  insert() {
    debugger
    this.APPeriodId = CryptoJS.AES.decrypt(localStorage.getItem("APPeriodId"), "APS").toString(CryptoJS.enc.Utf8);
    this.statementform.controls['APPeriodId'].setValue(this.APPeriodId);
    this.statementform.controls['CreatedBy'].setValue(localStorage.getItem('LoginuserId'));
    const formdata = this.statementform.getRawValue();
    this.Statementcompliance.addstatement(formdata).subscribe((data) => {
      debugger;
      this.statementform.markAsPristine();
      if (this.NormalRoutng)
        return true;
      var nextPage;
      nextPage = this.commonService.getNextNoteSelection("Statement of Compliance", this.commonService.NotesList)
      if (this.isJump == 'true')
        this.router.navigate(['/notes'])
      else if (nextPage == 'statementofcompliance') {
        nextPage = this.commonService.getNextPageSelection("Notes", this.commonService.allPagesdata)
        this.router.navigate([nextPage]);
      }
      else {
        this.router.navigate([nextPage]);
      }
    })
  }
  getstatement(APPeriodId) {
    debugger
    this.APPeriodId = CryptoJS.AES.decrypt(localStorage.getItem("APPeriodId"), "APS").toString(CryptoJS.enc.Utf8);
    this.Statementcompliance.getstatement(this.APPeriodId).subscribe((data: any) => {
      this.commonService.getNotesData();
    })
  }
  getlastyeardata() {
    this.Statementcompliance.getstatementLY(this.APPeriodId).subscribe((data: any) => {
      this.showBubbledata = data;
    })
  }
  back() {
    debugger;
    this.statementform.markAsPristine();
    localStorage.setItem("Backbutton", "true");
    var backpage;
    backpage = this.commonService.getBackSelection("Statement of Compliance", this.commonService.NotesList)
    if (this.isJump == 'true')
      this.router.navigate(['/notes'])
    else if (backpage == 'statementofcompliance')
      this.router.navigate(['/notes']);
    else {
      backpage = this.commonService.getBackSelection("Statement of Compliance", this.commonService.NotesList)
      this.router.navigate([backpage]);
    }
  }

  canDeactivate(): Observable<boolean> | Promise<boolean> | boolean {
    debugger;
    if (this.statementform.dirty) {
      return Swal.fire({
        title: "Andica Accounts Production",
        html: "<span style='font-weight: 900'>You have unsaved data.</span> <br>Do you want to save your changes before leaving?",
        icon: "warning",
        confirmButtonText: "Save Changes",
        showCancelButton: true,
        cancelButtonText: "Discard Changes",
        allowOutsideClick: false
      }).then((result) => {
        if (result.value) {
          this.NormalRoutng = true;
          this.insert();
          return true;
        }
        else {
          return true;
        }
      })
    }
    else if (this.commonService.routeToCompanyList) {
      return true
    }
  }

  TotalBack() {
    debugger;
    this.commonService.DisplayAccountingPeriodlist = true;
    this.router.navigate(['/business']);

  }

}
